<span class="mat-button-wrapper"><ng-content></ng-content></span>
<div matRipple class="mat-button-ripple"
     [class.mat-button-ripple-round]="isRoundButton || isIconButton"
     [matRippleDisabled]="_isRippleDisabled()"
     [matRippleCentered]="isIconButton"
     [matRippleTrigger]="_getHostElement()"></div>
<div class="mat-button-focus-overlay"></div>
